const TEST_SERVER = 'https://localhost:3000';
const PROD_SERVER = 'https://api.furtrieve.com';

export const env = process.env.NODE_ENV;
export const API_URL = env === 'development' ? PROD_SERVER : PROD_SERVER;
